module.exports = __webpack_public_path__ + "static/scan-19347662ed2188bd42a2ba6fbfb32170.jpg";